import cx from 'classnames'
import { RawButton } from '@/components/Button'
import { Icon } from '@/components/Icon'
import { SearchField } from '@/components/SearchField'
import styles from './WorkspaceSelector.module.css'
import { Checkbox } from '@/components/Checkbox'

export interface WorkspaceSelectorItem {
  id: string
  slug: string
  name: string
  iconUrl: string
  isSelected: boolean
  onSelect: () => unknown
}

export interface WorkspaceSelectorProps {
  isOpen: boolean
  showDefaultToAllWorkspaces: boolean
  isDefaultToAllWorkspaces: boolean
  onToggleDefaultToAllWorkspaces: () => unknown
  searchText: string
  onSearchTextChange: (text: string) => unknown
  workspaces: WorkspaceSelectorItem[]
  onAddWorkspace: () => unknown
}

export function WorkspaceSelector({
  isOpen,
  showDefaultToAllWorkspaces,
  isDefaultToAllWorkspaces,
  onToggleDefaultToAllWorkspaces,
  searchText,
  onSearchTextChange,
  workspaces,
  onAddWorkspace,
}: WorkspaceSelectorProps) {
  return (
    <div
      className={cx(styles.selector, isOpen ? styles.expanded : styles.closed)}
      data-test="WorkspaceSelector"
    >
      <div className={styles.titlebar}>
        <h4>Switch Workspace</h4>
      </div>
      {showDefaultToAllWorkspaces && (
        <div className={styles.defaultToAllWorkspacesCheckboxContainer}>
          <Checkbox
            checked={isDefaultToAllWorkspaces}
            onChange={() => onToggleDefaultToAllWorkspaces()}
            testId="workspace-selector-all-workspaces-checkbox"
          />
          <p>
            Default to <strong>All Workspaces</strong>
          </p>
        </div>
      )}
      <div className={styles.searchbar}>
        <SearchField
          appearance="outlined"
          stretch
          className={styles.search}
          value={searchText}
          onChange={onSearchTextChange}
        />
      </div>
      <div className={styles.list}>
        {workspaces.map((workspace) => (
          <div key={workspace.id}>
            <RawButton
              testId={`WorkspaceItem(${workspace.slug})`}
              className={cx(
                styles.listItemContent,
                workspace.isSelected && styles.selected,
              )}
              onPress={workspace.onSelect}
            >
              <div className={styles.icon}>
                <img src={workspace.iconUrl || undefined} alt="" />
              </div>
              <div className={styles.text}>
                <h4 className={styles.name}>{workspace.name}</h4>
                <p className={styles.slug}>{workspace.slug}</p>
              </div>
              <div className={styles.arrow}>
                <Icon name="arrow" />
              </div>
            </RawButton>
          </div>
        ))}
        <div>
          <RawButton
            title="Add workspace"
            className={styles.listItemContent}
            onPress={() => onAddWorkspace()}
          >
            <div className={styles.icon}>
              <Icon name="add" />
            </div>
            <div className={styles.text}>
              <h4>Add new workspace</h4>
            </div>
          </RawButton>
        </div>
      </div>
    </div>
  )
}
